<div class="container py-4">
  <section class="mb-4 d-flex align-items-start justify-content-between">
    <div>
      <div class="feedback-participant-name h4 font-weight-bold mb-0">{{ view.participantName }}</div>
      <a class="text-muted d-block mt-2" [href]="eventUrl" target="_blank" rel="noopener">{{ view.eventName }}</a>
      <a class="text-muted d-block" [href]="resultsUrl" target="_blank" rel="noopener">{{ view.categoryName }}</a>
    </div>
    @if (totalPrograms > 1) {
      <button type="button" class="btn btn-outline-primary" (click)="toggleAll()">
        {{ (anyExpanded() ? 'viewFeedback.collapseAll' : 'viewFeedback.expandAll') | translate }}
      </button>
    }
  </section>

  @if (rounds.length === 0) {
    <div class="text-center py-5">
      <h2 class="section-heading">{{ 'viewFeedback.empty.title' | translate }}</h2>
    </div>
  }

  @for (round of rounds; track $index) {
    <div class="mb-4">
      @for (program of round.programs; track $index) {
        <div class="feedback-program sh-block overflow-hidden mb-3">
          @if (totalPrograms > 1) {
            <button
              type="button"
              class="feedback-program__header d-flex align-items-center justify-content-between w-100 bg-primary border-0 text-left text-white"
              (click)="toggleProgram(program)"
            >
              <span class="d-flex align-items-center">
                <span class="feedback-chevron text-white mr-2" [class.feedback-chevron--open]="!program.collapsed"
                  >&rsaquo;</span
                >
                <span class="font-weight-bold">{{ round.roundName }}</span>
              </span>
            </button>
          }

          @if (!program.collapsed) {
            <div class="feedback-program__body bg-white">
              @for (section of program.sections; track section.label) {
                <div class="feedback-section">
                  <button
                    type="button"
                    class="feedback-section__title d-flex align-items-center justify-content-between w-100 bg-info border-0 text-white"
                    (click)="toggleSection(section)"
                  >
                    <span>{{ section.label }}</span>
                    <span
                      class="feedback-section__chevron d-inline-block"
                      [class.feedback-section__chevron--collapsed]="section.collapsed"
                      >&rsaquo;</span
                    >
                  </button>

                  @if (!section.collapsed) {
                    @if (section.kind === 'table') {
                      <iframe
                        class="feedback-table__frame d-block w-100 border-0"
                        [src]="section.table.url"
                        [style.height.px]="section.table.height"
                        [title]="'viewFeedback.pointsTableTitle' | translate: { label: section.label }"
                        sandbox="allow-scripts allow-same-origin"
                      ></iframe>
                    } @else {
                      @for (item of section.feedbacks; track item.judgeCode) {
                        <div class="feedback-judge d-flex flex-column align-items-start">
                          <div
                            class="feedback-judge__header d-flex align-items-baseline justify-content-between w-100 mb-1"
                          >
                            <span class="feedback-judge__code text-primary mr-3"
                              >{{ item.judgeCode }}
                              @if (section.showScores && item.judgeValues?.['value1'] != null) {
                                <span class="feedback-judge__score text-primary">
                                  - {{ item.judgeValues['value1'] | number: '1.1-1' }}</span
                                >
                              }
                            </span>
                          </div>
                          @if (item.feedback) {
                            <span class="feedback-judge__text">{{ item.feedback }}</span>
                          } @else {
                            <span class="feedback-judge__text text-muted font-italic">{{
                              'viewFeedback.awaitingFeedback' | translate
                            }}</span>
                          }
                        </div>
                      }
                    }
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
</div>
